/*
 * <cart-attribute> — persists a cart attribute input to the cart as the customer edits it.
 *
 * Custom (non-vendor) file. Loaded with defer from snippets/cart-card-message.liquid, which is
 * the only consumer: the Card-To / Card-From / Card-Message gift fields on the cart page.
 * See docs/CUSTOMIZATIONS.md section 3.
 *
 * This element existed in the v2.0.0 theme as an inline {% javascript %} block inside
 * sections/main-cart-footer.liquid. That block was lost when the section was replaced with the
 * v16 vendor version, so the markup rendered but nothing wrote the values back to the cart.
 * Keeping it in its own asset — rather than back inside the section — means the next vendor
 * section upgrade can't silently drop it again.
 *
 * Belt-and-braces: the inputs also carry form="cart", so the checkout POST submits
 * attributes[...] directly even if this script never runs. This is the same pattern vendor uses
 * for the cart note (cart.js CartNote + form="cart" on the textarea).
 */
if (!customElements.get('cart-attribute')) {
  customElements.define(
    'cart-attribute',
    class CartAttribute extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const key = this.attributeKeyFor(event.target);
            if (!key) return;

            const body = JSON.stringify({ attributes: { [key]: event.target.value } });

            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then((response) => response.json())
              .then((cart) => {
                if (!cart || cart.errors) {
                  throw new Error(cart?.errors || 'Cart attribute update failed');
                }
              })
              .catch((error) => {
                // Non-fatal: form="cart" on the input still carries the value to checkout.
                console.error('cart-attribute update failed', error);
              });
          }, 300)
        );
      }

      // Reads the key out of name="attributes[Card-To]"; falls back to the element id, which is
      // what the v2.0.0 implementation keyed off.
      attributeKeyFor(input) {
        const match = (input.name || '').match(/^attributes\[(.+)\]$/);
        return match ? match[1] : input.id;
      }
    }
  );
}
